import { CountryCodes } from '@descope/page-editor-components';

export const autoDetectOption = 'autoDetect';
export const countryCodeOptions = [autoDetectOption].concat(
	CountryCodes.map(({ code }) => code)
);
